/* clickable-cart-drawer-defer.js — the cart DRAWER never fetches line-item
 * images until it opens (Lucas, 21 Aug). The drawer is hidden on every page,
 * and Safari fetches hidden `loading="lazy"` images anyway — so the thumbs +
 * disclosure symbols render with a transparent 1x1 data-URI src and the real
 * URL on `data-ck-defer-src`. This controller swaps them in on first open
 * (and on any re-render that lands while the drawer is open).
 *
 * FAIL SAFE: if this script never runs, the drawer simply shows placeholder
 * boxes — the reserved width/height keep the layout correct; nothing breaks.
 * The visible CART PAGE renders its images eagerly (no defer flag) — this is
 * drawer-only.
 */
(function () {
  'use strict';
  if (window.__ckCartDeferLoaded) return; /* run-once (rule 21) */
  window.__ckCartDeferLoaded = true;

  function swap(scope) {
    var root = scope || document.getElementById('CartDrawer');
    if (!root) return;
    /* the empty-state illustration only matters when the cart is empty;
       reveal it only then, so a non-empty open never fetches a hidden
       illustration (Lucas, 21 Aug). */
    var drawer = document.querySelector('cart-drawer');
    var isEmpty = !!drawer && drawer.classList.contains('is-empty');
    var imgs = root.querySelectorAll('img[data-ck-defer-src]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (!isEmpty && img.closest && img.closest('.drawer__inner-empty')) continue;
      var ss = img.getAttribute('data-ck-defer-srcset');
      if (ss) { img.setAttribute('srcset', ss); img.removeAttribute('data-ck-defer-srcset'); }
      img.setAttribute('src', img.getAttribute('data-ck-defer-src'));
      img.removeAttribute('data-ck-defer-src');
    }
  }
  /* exposed so the re-render path (clickableRefreshDrawer) can force a
     reveal explicitly, and for tests */
  window.clickableCartDrawerRevealImages = swap;

  function isOpen(drawer) {
    /* Dawn's cart-drawer.open() adds `active` to the <cart-drawer> CUSTOM
       ELEMENT (the wrapper), NOT the inner #CartDrawer div — observe and
       test the custom element. */
    return !!drawer && drawer.classList.contains('active');
  }

  function init() {
    /* the <cart-drawer> custom element is the wrapper that gains `active`;
       it CONTAINS #CartDrawer + the deferred imgs, so it is both the open
       signal and the swap scope. */
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (isOpen(drawer)) swap(drawer); /* already open at init (rare) */
    /* Reveal on: the drawer gaining `active` (open), and any childList
       re-render (section render / clickableRefreshDrawer innerHTML swap)
       that lands WHILE open. A closed re-render leaves images deferred.
       swap() only mutates image attributes (src/srcset/data-*), which the
       class+childList filters ignore, so it never re-triggers this. */
    var mo = new MutationObserver(function () {
      if (isOpen(drawer)) swap(drawer);
    });
    mo.observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
